import { useCallback, useEffect, useRef, useState } from 'react';

import serviceEndpoints from '../../../../api/services/serviceEndpoints';
import helpers from '../../../../utils/helpers';

export const useFetchServices = () => {
  const [loading, setLoading] = useState();
  const [services, setServices] = useState([])
  const isMounted = useRef(true)

  const fetchAllServices = useCallback(async () => {
    setLoading(true);
    if (services.length === 0) {
        try {
          const response = await serviceEndpoints.getAllServices()
          if(response.status === 200) {
            if(isMounted.current) {
              let data = helpers.ordernarArray({data:response.data, field: 'cdServico'}) ;
              setServices(data)
            }
          }
        } finally {
          setLoading(false);
        }
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    fetchAllServices().catch(console.error);
    return () => {
      isMounted.current = false;
    };
  }, [fetchAllServices]);

  return {
    loading,
    services,
  };
};